import { TextField, Button, Grid } from '@mui/material';
import { useSnackbar } from 'notistack';
import { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { validateJobExists } from '../../../fetch';

interface IJobSearch {}

export const JobSearch: FC<IJobSearch> = () => {
  const [jobId, setJobId] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  return (
    <>
      <Grid spacing={1} container>
        <Grid item xs={12} md={4} lg={3}>
          <TextField
            fullWidth
            variant="outlined"
            autoComplete="nope"
            label="Job ID"
            name="jobId"
            size="small"
            value={jobId}
            onChange={e => {
              const re = /^[0-9\b]+$/;
              // if value is not blank, then test the regex
              if (e.target.value === '' || re.test(e.target.value)) {
                setJobId(e.target.value);
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={2.7} xl={1.5}>
          <Button
            color="secondary"
            variant={'contained'}
            disabled={!jobId || isSearching}
            fullWidth
            onClick={async e => {
              try {
                setIsSearching(true);
                const validatedId = await validateJobExists(jobId);
                history.push(`/development/jobs/${validatedId}/general-information`);
              } catch (error) {
                enqueueSnackbar(error?.Detail || `Job ID does not exist.`, {
                  variant: 'error'
                });
              } finally {
                setIsSearching(false);
              }
            }}
          >
            Go to Job
          </Button>
        </Grid>
      </Grid>
    </>
  );
};
